import { Search, SkipForward } from "lucide-react";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";
import { Button } from "./ui/button";
import { STATUS_LABELS, fmtNum, parseAmount, firstLine } from "../lib/format";

export const EMPTY_FILTERS = { onlyOpen: false, status: "alle", q: "", amount: "", min: "" };

export const applyFilters = (txs, f) => {
  const q = f.q.trim().toLowerCase();
  const amt = f.amount.trim().replace(/^[-+]/, "").replace(/-$/, "");
  const amtNum = parseAmount(amt);
  return txs.filter((t) => {
    if (f.min && Math.abs(t.amount) < Number(f.min)) return false;
    if (f.onlyOpen && t.status !== "offen") return false;
    if (f.status !== "alle" && t.status !== f.status) return false;
    if (q) {
      const hay = [t.ai?.merchant_clean, t.counterparty_raw, t.booking_text, t.notes, t.ai?.category, t.reference].join(" ").toLowerCase();
      if (!hay.includes(q)) return false;
    }
    if (amt) {
      const a = Math.abs(t.amount);
      const eq = amtNum !== null && Math.abs(a - Math.abs(amtNum)) < 0.005;
      if (!eq && !fmtNum(a).includes(amt) && !fmtNum(a).replace(/\./g, "").includes(amt)) return false;
    }
    return true;
  });
};

export const FilterBar = ({ f, set, shown, total, onNextOpen, autoJump, setAutoJump }) => (
  <div className="grid gap-3 rounded-xl border border-slate-200 bg-white p-3" data-testid="filter-bar">
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative min-w-[180px] flex-1">
        <Search className="absolute left-2.5 top-3 h-4 w-4 text-slate-400" />
        <Input value={f.q} onChange={(e) => set({ ...f, q: e.target.value })} placeholder="Suche Händler, Text, Notiz …" className="h-10 pl-8" data-testid="filter-search-input" />
      </div>
      <Input value={f.amount} onChange={(e) => set({ ...f, amount: e.target.value })} placeholder="Betrag" className="font-num h-10 w-28" data-testid="filter-amount-input" />
      <select value={f.status} onChange={(e) => set({ ...f, status: e.target.value })} data-testid="filter-status-select" className="h-10 rounded-md border border-input bg-white px-2 text-sm">
        <option value="alle">Alle Status</option>
        {Object.entries(STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
      </select>
      <label className="flex h-10 items-center gap-2 rounded-md border border-slate-200 px-3 text-sm font-medium text-slate-700">
        <Switch checked={f.onlyOpen} onCheckedChange={(v) => set({ ...f, onlyOpen: v })} data-testid="filter-only-open-switch" /> Nur offene
      </label>
      <Button onClick={onNextOpen} data-testid="next-open-btn" className="h-10 gap-1.5 bg-slate-900 hover:bg-slate-800"><SkipForward className="h-4 w-4" />Nächste offene Buchung</Button>
    </div>
    <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-slate-500">
      <span data-testid="filter-count"><span className="font-num font-semibold text-slate-800">{shown}</span> von <span className="font-num">{total}</span> Buchungen</span>
      {f.min && <button onClick={() => set({ ...f, min: "" })} className="rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-900" data-testid="filter-min-chip">ab {f.min} € ✕</button>}
      <label className="flex items-center gap-2">
        <Switch checked={autoJump} onCheckedChange={setAutoJump} data-testid="auto-jump-switch" /> Nach Erledigen automatisch zur nächsten offenen
      </label>
      <span className="hidden lg:inline" data-testid="keyboard-hint">Tastatur: <kbd className="rounded border bg-slate-50 px-1 font-num">J</kbd>/<kbd className="rounded border bg-slate-50 px-1 font-num">K</kbd> nächste/vorherige · <kbd className="rounded border bg-slate-50 px-1 font-num">N</kbd> nächste offene</span>
    </div>
  </div>
);

export const txLabel = (t) => t.ai?.merchant_clean || t.counterparty_raw || firstLine(t.booking_text);
